// extracted by mini-css-extract-plugin
export default {"logo":"index__logo___2iehI","black":"index__black___2myk-"};